const importSources = {
	BIBLIO: "biblio",
	MOCKINGBIRD: "mockingbird",
};

export default importSources;
